// import React, { useState } from "react";

// const ForgotPassword = () => {
//   const [step, setStep] = useState(1);
//   const [email, setEmail] = useState("");
//   const [otp, setOtp] = useState("");
//   const [newPassword, setNewPassword] = useState("");

//   // STEP 1 - Send OTP
//   const sendOtp = async () => {
//     try {
//       console.log("Sending OTP request...");

//       const res = await fetch(
//         "https://ideal-nature-production-df86.up.railway.app/api/auth/send-otp",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ email }),
//         }
//       );

//       const data = await res.json();
//       console.log("OTP RESPONSE:", data);

//       if (res.ok && data.msg === "OTP Sent") {
//         alert("OTP Sent to Email");
//         setStep(2);
//       } else {
//         alert(data.msg || "Something went wrong");
//       }
//     } catch (err) {
//       console.error("SEND OTP ERROR:", err);
//       alert("Server Error");
//     }
//   };

//   // STEP 2 - Verify OTP
//   const verifyOtp = async () => {
//     try {
//       console.log("Verifying OTP...");

//       const res = await fetch(
//         "https://ideal-nature-production-df86.up.railway.app/api/auth/verify-otp",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ email, otp, newPassword }),
//         }
//       );

//       const data = await res.json();
//       console.log("VERIFY RESPONSE:", data);

//       if (res.ok && data.msg === "Password Updated") {
//         alert("Password Updated!");
//         window.location.href = "/login";
//       } else {
//         alert(data.msg || "Wrong OTP");
//       }
//     } catch (err) {
//       console.error("VERIFY OTP ERROR:", err);
//       alert("Server Error");
//     }
//   };

//   return (
//     <div className="min-h-screen flex items-center justify-center bg-[#faf9f6]">
//       <div className="bg-white p-10 rounded-3xl shadow-xl w-full max-w-md">
//         {step === 1 && (
//           <>
//             <h2 className="text-2xl mb-4 text-center">Forgot Password</h2>
//             <input
//               type="email"
//               placeholder="Enter Email"
//               className="w-full border p-3 rounded-xl mb-4"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//             />
//             <button
//               onClick={sendOtp}
//               className="w-full bg-[#e0be9c] p-3 rounded-xl"
//             >
//               Send OTP
//             </button>
//           </>
//         )}

//         {step === 2 && (
//           <>
//             <h2 className="text-2xl mb-4 text-center">Verify OTP</h2>
//             <input
//               placeholder="Enter OTP"
//               className="w-full border p-3 rounded-xl mb-4"
//               value={otp}
//               onChange={(e) => setOtp(e.target.value)}
//             />
//             <input
//               type="password"
//               placeholder="New Password"
//               className="w-full border p-3 rounded-xl mb-4"
//               value={newPassword}
//               onChange={(e) => setNewPassword(e.target.value)}
//             />
//             <button
//               onClick={verifyOtp}
//               className="w-full bg-[#e0be9c] p-3 rounded-xl"
//             >
//               Reset Password
//             </button>
//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// export default ForgotPassword;



import React, { useState } from "react";
import { supabase } from "../supabaseClient";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleReset = async () => {
    if (!email) {
      alert("Enter your email");
      return;
    }

    try {
      setLoading(true);

      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: window.location.origin + "/reset-password",
      });

      if (error) {
        alert(error.message);
        return;
      }

      alert("Password reset email sent. Check your inbox.");
    } catch (err) {
      alert("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#faf9f6]">
      <div className="bg-white p-10 rounded-3xl shadow-xl w-full max-w-md">
        <h2 className="text-2xl mb-4 text-center">Forgot Password</h2>

        <input
          type="email"
          placeholder="Enter Email"
          className="w-full border p-3 rounded-xl mb-4"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <button
          onClick={handleReset}
          disabled={loading}
          className="w-full bg-[#e0be9c] p-3 rounded-xl"
        >
          {loading ? "Sending..." : "Send Reset Link"}
        </button>
      </div>
    </div>
  );
};

export default ForgotPassword;